export default "__VITE_ASSET__245749e6__"